import { EnquiryLifecycleStatusEnum } from "@gtpl/shared-models/enquiry-management";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { EnquiriesEntity } from "./enquiries";

@Entity("enquiry_log")
export class EnquiryLogEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"enquiry_log_id"
    }) 
    enquiryLogId: number;

    @Column('varchar',{
        name:'enquiry_number',
        nullable:false,
        length:50
    })
    enquiryNumber: string

    @Column('enum',{
        name:'enquiry_status',
        nullable:false,
        enum:EnquiryLifecycleStatusEnum
    })
    enquiryStatus : EnquiryLifecycleStatusEnum

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.enquiryLog )
    @JoinColumn({name:'enquiry_id'})
    enquiryEntity : EnquiriesEntity
}